import { useEffect, useState } from 'react'

import { createStyles, Theme, makeStyles } from '@material-ui/core/styles'
import { Button, CircularProgress, Grid, Paper, TextField, Typography } from '@material-ui/core'
import { useAuth } from '@Hooks/useAuth'
import { clearCacheApi } from '../../api/clearCache'
import { useSnackbar } from '@Hooks/useSnackbar'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      width: '100%',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2),
      minHeight: 150,
      padding: theme.spacing(2),
    },
    spaceRow: {
      justifyContent: 'center',
      alignContent: 'center',
      marginTop: theme.spacing(2),
      gap: 10
    },
    grow: {
      flexGrow: 1,
    },
    divider: {
      marginBlock: theme.spacing(1),
    },
    formControl: {
      minWidth: '100%',
    },
    textLabel: {
      margin: theme.spacing(0.5),
      textAlign: 'right',
      fontWeight: 500,
      fontSize: 21,

    },
  }),
)

export default function CdnPurgePage() {
  const classes = useStyles()
  const [url, setUrl] = useState<string>('')
  const [isError, setIsError] = useState<boolean>(false);
  const [erres, setErrors] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { onToggle } = useSnackbar()

  const { user } = useAuth()

  const validateFormData = (data: string) => {
    let errors = [];
    const regex = /^https:\/\/mirrorthailand\.com(\/.*)?$/;

    if (!data && data.length < 4) errors.push("กรุณาใส่ URL ที่ต้องการเคลียร์แคช");
    if (data && !regex.test(data)) errors.push("กรุณาใส่ URL ที่ถูกต้อง");


    if (errors.length > 0) setIsError(true);
    else setIsError(false);

    return errors;
  };


  const onPurge = () => {
    setIsLoading(true);
    const error = validateFormData(url);

    if (error.length > 0) {
      setErrors(error);
      setIsLoading(false);
    } else {
      setErrors([])
      getClearCacheApi(url);
    }

  }

  const getClearCacheApi = async (url: string) => {
    setIsLoading(true);

    const response = await clearCacheApi({ url, user })

    if (response === 200) {
      setIsLoading(false);  
      onToggle({ type: 'success', open: true, message: 'เคลียร์แคชสำเร็จ!' })
    }
  }

  return (
    <>
      <Paper className={classes.paper}>
        <Grid container>
          <Grid item>
            <Typography variant="h6">เคลียร์แคช (CDN Purge)</Typography>
          </Grid>
          <div className={classes.grow} />
          <Grid container className={classes.spaceRow} >
            <Grid item xs={3} sm={3} lg={1}>
              <div className={classes.textLabel}>URL: </div>
            </Grid>
            <Grid item xs={6} sm={5}  >
              <TextField
                id="standard-basic"
                variant="outlined"
                size="small"
                fullWidth
                defaultValue={url}
                autoComplete='off'
                onChange={(e) =>
                  setUrl(e.target.value)
                }
              />
            </Grid>
            <Grid item xs={3} sm={3} lg={1}>
              <Button
                variant="outlined"
                type="submit"
                onClick={() => onPurge()}
              >{isLoading ? <CircularProgress size={24} /> : 'เคลียร์'}</Button>
            </Grid>
          </Grid>
          <Grid container className={classes.spaceRow} >
            <p style={{ color: 'red' }}>{erres}</p>
          </Grid>
        </Grid>
      </Paper>
    </>
  )
}
